import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'Out H',
      outP: 'P records',
      sendDoc: {
        action: 'Send doc',
      },
      checkDocs: {
        action: 'Check docs',
      },
      enums: {
        docType: {
          DECLARATION: 'DECLARATION',
        },
        status: {
          CHECKED_NOT_OK: 'CHECKED_NOT_OK',
          CHECKED_OK: 'CHECKED_OK',
        },
      },
      fields: {
        fileId: 'File id',
        id: 'Id',
        dateSend: 'Send date',
        docType: 'Document type',
        regDate: 'Registration date',
        decisionDate: 'Decision date',
        docDateCertificate: 'Document certificate date',
        docDatePaper: 'Paper document date',
        status: 'Status',
      },
    },
  },
};
